import React, { Component } from 'react';
import * as Actions from 'containers/Home/actions';
import * as statusActions from './actions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { globalData } from 'global/js/globalData';
import Loader from 'components/Loader/Loader';
import Error from 'components/Error/Error';
import './submission-status.scss';

class SubmissionStatus extends Component {
    constructor(props) {
        super(props);

        this.survey = JSON.parse(localStorage.getItem('survey'));
        this.dirtyStay = null;
        this.dirtyOverall = null;
    }

    componentDidMount() {
        if (this.survey) this.checkDirtySubmissions();
    }

    /**
     * Loops through all of the stay submissions and the overall
     * submissions to determine if any of them have data that
     * has not been sent back. Sets the submission status based on
     * whether or not any unsent data was found.
     */
    checkDirtySubmissions = () => {
        for (const stay of this.survey.StaySubmissions)
            if (stay.Submission.isDirty) 
                this.dirtyStay = stay;

        if (this.survey.OverallSubmission.Submission.isDirty)
            this.dirtyOverall = this.survey.OverallSubmission;

        this.props.statusActions.setUnsentSubmissionStatus(
            !!(this.dirtyStay || this.dirtyOverall)
        );
    };

    /**
     * Called when the submit button is clicked. Checks all stays and overall
     * sections for unsent data, and sends any 'dirty' data to the relavent
     * endpoint.
     */
    handleClick = () => {
        const prodID = this.survey.Evaluator.ProdTourDetail.ProdTourId;
        const individualID = this.survey.Evaluator.SalesIndividualId;

        // Send back the stay data if it's dirty.
        if (this.dirtyStay) {
            this.dirtyStay.Submission.Source = 'Tour Director';
            this.dirtyStay.Submission.IsComplete = true;
            this.dirtyStay.Submission.IsSubmitted = true;
            this.sendUnsentData(
                prodID, 
                individualID, 
                '/stay', 
                this.dirtyStay,
                this.props.token
            );
        }

        // Send back the overall data if it's dirty.
        if (this.dirtyOverall) {
            this.dirtyOverall.Submission.Source = 'Tour Director';
            this.dirtyOverall.Submission.IsComplete = true;
            this.dirtyOverall.Submission.IsSubmitted = true;
            this.sendUnsentData(
                prodID,
                individualID,
                '/overall',
                this.dirtyOverall,
                this.props.token
            );
        }
    };

    /**
     * Calls the action to send data back to the server, using the
     * provided values.
     *
     * @param {Number} : prodID
     * @param {Number} : individualID
     * @param {String} : endPoint
     * @param {Object} : sendData
     * @param {String} : token
     */
    Data = (prodID, individualID, endPoint, sendData, token) => {
        console.log("SENDING UNSENT DATA: ", sendData);
        this.props.actions.sendSurveyData(
            prodID,
            individualID,
            null,
            null,
            endPoint,
            sendData,
            false,
            true,
            token
        );
    };

    render() {
        const { didPostFail, isDataUnsent, isDataPosted, isDataPosting } = this.props;
        const buttonClasses = classNames('btn', { disabled: !isDataUnsent });
        const unsentAnswersMessage = this.survey.Evaluator.FirstName + ' ' + 
            this.survey.Evaluator.LastName + ' ' + globalData.unsentAnswersMessage;
        const submissionStatusMessage = isDataUnsent ? unsentAnswersMessage : globalData.noUnsentAnswersMessage

        return (
            <div className="wrapper submission-status">
                <header className="submission-status__header">OnTour</header>

                {didPostFail && (
                    <Error
                        errorText={globalData.errorMessages.submissionStatus}
                    />
                )}

                {isDataPosted && 
                    <h1 className="submission-status__message--success">
                        {globalData.tdSuccessfullSendMessage}
                    </h1>
                }

                {!isDataPosted && 
                    <section className="submission-status__container">
                        <p className="submission-status__message">
                            {submissionStatusMessage}
                        </p>

                        <a className={buttonClasses} onClick={this.handleClick}>
                            {isDataPosting && <Loader />} Submit
                        </a>
                    </section>
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        didPostFail: state.surveyReducer.didPostFail,
        isDataPosted: state.surveyReducer.isDataPosted,
        isDataPosting: state.surveyReducer.isDataPosting,
        isDataUnsent: state.dataReducer.isDataUnsent,
        token: state.dataReducer.token
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(Actions, dispatch),
        statusActions: bindActionCreators(statusActions, dispatch)
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SubmissionStatus);



// WEBPACK FOOTER //
// ./application/containers/SubmissionStatus/SubmissionStatus.jsx